import React, { useState, useEffect } from 'react';
import "../style/Images.css";
import Loader from './Loader';


const Images = () => {

    const [load, setLoad] = useState(true);
    // products
    const [data, setData] = useState([]);
    // category
    const [filter, setFilter] = useState('All');

    const getImages = async () => {
        const dataImage = await fetch('https://imagepicker.onrender.com/get/route');
        setData(await dataImage.json());
        setLoad(false);
    }

    useEffect(() => {
        getImages();
        window.alert("Message: Please reload the page if Filter doesn't work!");
    }, []);

    useEffect(() => {

        if(filter === 'Nature'){
            const filteredProducts = data.filter(item => item.category === 'Nature') 
            setData(filteredProducts);
        }

        else if(filter === 'Fitness'){
            const filteredProducts = data.filter(item => item.category === 'Fitness')
            setData(filteredProducts);
        }

        else if(filter === 'Food'){
            const filteredProducts = data.filter(item => item.category === 'Food')
            setData(filteredProducts);
        }

        else if(filter === 'Travelling'){
            const filteredProducts = data.filter(item => item.category === 'Travelling')
            setData(filteredProducts);
        }
    }, [filter])

    if(load){
        return < Loader/>
    }

    return(
        <>

        <div class='categories_filter'>
            <p onClick={() => setFilter('Nature')}>Nature</p>
            <p onClick={() => setFilter('Fitness')}>Fitness</p>
            <p onClick={() => setFilter('Food')}>Food</p>
            <p onClick={() => setFilter('Travelling')}>Travelling</p>
        </div>

         <div class="image_container">
            {
                data.map((data) => {
                    const { id, name, category, image } = data;
                    return (
                        <>
                            <div class='image_grid'>
                                <div class='img'>
                                    <a href={image} download>
                                        <img src={image}/>
                                    </a>
                                <div class='d-flex'>
                                    <p>{name}</p>
                                    <p>{category}</p>
                                </div>
                                </div>
                            </div>
                        </>
                    )
                })
            }
         </div>
        </>
    )
}

export default Images;
